<template>
<div>
    <ul class="accordion js-accordion accordion-unmounted" :class="marginBottom" data-animation="on" data-multi-items="off">
        <li v-for="(group, index) in groupsWithCookies" v-bind:key="index" class="accordion__item js-accordion__item">
            <button class="reset accordion__header padding-y-sm js-tab-focus" type="button" :class="paddingX">
                <span class="text-md">{{ group.name }}</span>

                <div>
                    <div class="switch margin-right-xs" @click.stop>
                        <input class="switch__input" type="checkbox" :id="'switch-checkbox-' + index + '-' + initiator" v-model="group.consent" v-on:change="callEvent(group.consent, group.name)" disabled v-if="group.type === 'functional'">
                        <input class="switch__input" type="checkbox" :id="'switch-checkbox-' + index + '-' + initiator" v-model="group.consent" v-on:change="callEvent(group.consent, group.name)" v-else>
                        <label class="switch__label" :for="'switch-checkbox-' + index + '-' + initiator" aria-hidden="true">{{ $t("toggle_tracking") }}</label>
                        <div class="switch__marker" aria-hidden="true"></div>
                    </div>

                    <svg class="icon accordion__icon-arrow no-js:is-hidden" viewBox="0 0 20 20" aria-hidden="true">
                        <g class="icon__group" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                        <line x1="10" y1="14" x2="3" y2="7" />
                        <line x1="17" y1="7" x2="10" y2="14" />
                        </g>
                    </svg>
                </div>
            </button>

            <div class="accordion__panel padding-top-xxs padding-bottom-md js-accordion__panel" :class="paddingX">
                <div class="text-component">
                    <div v-html="group.description"></div>
                    <button class="btn btn--primary unattached" :aria-controls="'drawer-' + index">{{ $t("details") }}</button>
                </div>
            </div>
        </li>
    </ul>
</div>
</template>

<script>
import { store } from './../store/index.js'

export default {
  name: 'QuickList',
  props: [ 'paddingX', 'marginBottom', 'initiator' ],
  data() {
      return {
          store
      }
  },
  computed: {
    groupsWithCookies: function () {
        return this.store.groups.filter(i => i.cookies.length)
    }
  },
  mounted() {
    let accordionJs = document.createElement('script');
    accordionJs.setAttribute('src', 'https://cdn.ampersand.company/js/accordion.js');
    accordionJs.setAttribute('id', 'accordion-js');
    
    document.body.appendChild(accordionJs);

    let drawerJs = document.createElement('script');
    drawerJs.setAttribute('src', 'https://cdn.ampersand.company/js/drawer.js');
    drawerJs.setAttribute('id', 'drawer-js');
    
    document.body.appendChild(drawerJs);
  },
  methods: {
    callEvent(consent, id) {
        if(consent) {
            window.dispatchEvent(new Event('on' + this.cleanGroupName(id) + 'ConsentGranted'));

            let consents;

            if(localStorage.getItem('ampsandConsent')) {
                consents = JSON.parse(localStorage.getItem('ampsandConsent'));
            } else {
                consents = [];
            }

            consents.push(this.cleanGroupName(id).toLowerCase());
            consents = [...new Set(consents)];
            localStorage.setItem('ampsandConsent', JSON.stringify(consents));
            localStorage.setItem('ampsandConsentUpdated', Date.now());
        } else {
            window.dispatchEvent(new Event('on' + this.cleanGroupName(id) + 'ConsentRevoked'));

            if(localStorage.getItem('ampsandConsent')) {
                let consents = JSON.parse(localStorage.getItem('ampsandConsent'));

                const consentIndex = consents.indexOf(this.cleanGroupName(id).toLowerCase());
                if (consentIndex > -1) {
                    consents.splice(consentIndex, 1);
                }

                localStorage.setItem('ampsandConsent', JSON.stringify(consents));
                localStorage.setItem('ampsandConsentUpdated', Date.now());
            }
        }

        localStorage.setItem('ampsandConsentPreferencesSet', 'true');
    },
    cleanGroupName(str) {
        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();

        // remove accents, swap ñ for n, etc
        var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
        var to   = "aaaaeeeeiiiioooouuuunc------";

        for (var i=0, l=from.length ; i<l ; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }

        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '') // collapse whitespace and replace by -
            .replace(/-+/g, '') // collapse dashes
            .replace('cookies', '');

        str = str.charAt(0).toUpperCase() + str.slice(1)

        return str;
    }
  }
}
</script>

<style lang="scss">
</style>
